import UploadWizard from './UploadWizard';

export default function UploadV2Page() {
  return (
    <div className="h-screen bg-card">
      <UploadWizard />
    </div>
  );
}
